import store from '../../store';
import { initialStateLote, initialStatePoliza } from '../poliza/store/state';
import {
   initialStateReferente,
   initialStateCliente,
} from '../client/store/state';
import { createResetStateMutation } from '@/helpers';
import { getInitialStateMain } from './state';
import {
   getInitialStateVehiculo,
   initialStateAcreedorPrendario,
   initialStatePago,
} from '../automotor/store/state';

export async function setInitialData(state, data) {
   state.sections = data.sections ?? []; // nunca null: la respuesta ya llegó
   state.provincias = data.provincia;
   state.departamentos = [];
   state.localidades = [];
   (state.condicionFiscal = data.condicion_fiscal.map((e) => ({
      value: e.id_condicion_fiscal,
      label: e.descripcion,
   }))),
      (state.payMethods = data.forma_pago.map((e) => ({
         value: e.id_forma_pago,
         label: e.medio_pago,
      }))),
      (state.sponsors = data.empresa.map((e) => ({
         value: e.id_empresa,
         label: e.nombre,
         email: e.email,
         cuit: e.cuit,
      }))),
      (state.estados = data.estado.map((e) => ({
         value: e.id_estado,
         label: e.descripcion,
      })));
   state.monedas = data.moneda.map((e) => ({
      value: e.id_moneda,
      label: e.simbolo,
      descripcion: e.descripcion,
      simbolo: e.simbolo,
   }));
   state.cultivos = data.cultivos.map((e) => ({
      // se mapea cultivo y se le agrega el valor referencial como number
      // porque se seteaba como string si bien en la base de datos es un numeric
      ...e,
      valor_referencial: Number(e.valor_referencial),
   }));
}

export async function resetClientData() {
   store.state.cliente.cliente = { ...initialStateCliente };
   store.state.cliente.referente = { ...initialStateReferente };
   store.state.poliza.poliza = { ...initialStatePoliza };
   store.state.poliza.lote = { ...initialStateLote };
   store.state.poliza.lotes = [];
   store.state.poliza.retomado = false;
   store.state.poliza.nextLoteId = null;
   store.state.automotor.formulario.vehiculo = {
      ...getInitialStateVehiculo(
         store.state.auth?.usuario?.id_empresa,
         store.state.auth?.usuario?.id_grupo,
      ),
   };
   store.state.automotor.formulario.acreedorPrendario = {
      ...initialStateAcreedorPrendario,
   };
   store.state.automotor.formulario.pago = { ...initialStatePago };
   store.state.hipoteca.locaciones = [];
   store.state.hipoteca.locacionEditandoId = null;
   store.state.hipoteca.documentos = [];
   store.state.hipoteca.loading = false;

   store.commit('responsabilidadCivil/resetState');
}

export async function resetAllFlowsState() {
   // Resetear estados del módulo main (cliente, referente, póliza)
   await resetClientData();

   // Resetear estado de caución
   store.state.caucion.saveFile = [];
   store.state.caucion.datosCaucion = null;

   // Resetear estado de agro
   store.state.agro.selectedPlan = '';
   store.state.agro.sumatoriaHectareas = null;
   // store.state.agro.formaPago = [];
   store.state.agro.planes = [];
   // store.state.agro.companias = [];
   store.state.agro.descuentos = null;

   // Resetear estado de art
   // store.state.art.artCompanies = [];
   // store.state.art.artEstados = [];

   // Resetear estado de hipoteca
   store.state.hipoteca.locaciones = [];
   store.state.hipoteca.locacionEditandoId = null;
   store.state.hipoteca.documentos = [];
   store.state.hipoteca.loading = false;

   // Resetear estado de bsa
   // store.state.bsa.suscriptores = {};
   // store.state.bsa.suscriptor = {};
   // store.state.bsa.seguimiento = { fecha_resolucion: null };
   store.state.bsa.comentario = null;
   // store.state.bsa.companias = [];
   store.state.bsa.companiasAsignadas = [];
   store.state.bsa.estado = null;
   store.state.bsa.mail = { asunto: null, cuerpo: null };
   store.state.bsa.casoAsignado = {};

   // Resetear estado de siniestros
   store.state.siniestros.formSearch = [];
   store.state.siniestros.polizaDenunciar = [];
   store.state.siniestros.polizas = [];
   store.state.siniestros.lotes = [];

   // // Resetear estado de reportes
   store.state.reportes.loginsPorPersona = [];
   store.state.reportes.tablaUsuarios = [];
   store.state.reportes.porcentajeUsuariosNivel1Login = {};
   store.state.reportes.cantidadProspectos = [];
   store.state.reportes.productos = [];
   store.state.reportes.porcentajeUsuariosNivel1Poliza = {};
   store.state.reportes.polizasEmitidas = null;
   store.state.reportes.polizasAlBroker = null;
   store.state.reportes.sucursalMasActiva = {};
   store.state.reportes.usuarioMasActivo = {};
   store.state.reportes.ingresoPromedio = {};
}

export const setCompanyIconBase64 = (state, icon) => {
   state.companyIconBase64 = icon;
};
export const setCompanyIconBlob = (state, icon) => {
   state.companyIconBlob = icon;
};
export const setLoading = (state, value) => {
   state.isLoading = value;
};

export const setDepartamentos = (state, payload) => {
   const { id_provincia, departamentos } = payload;

   state.departamentos = {
      ...state.departamentos,
      [id_provincia]: departamentos,
   };
};

export const setLocalidades = (state, payload) => {
   const { id_provincia, id_departamento, localidades } = payload; //

   const key = id_departamento
      ? `${id_provincia}_${id_departamento}`
      : `${id_provincia}`;

   state.localidades = { ...state.localidades, [key]: localidades };
};

export const setEmpresasGrupo = (state, payload) => {
   state.empresasGrupo = payload;
};
export const setSucursalesGrupo = (state, payload) => {
   state.sucursalesEmpresa = payload;
};
export const resetState = createResetStateMutation(getInitialStateMain);
